import React from 'react';
import { SelectableItemList } from '@shared/scenes/workflows/edit/components/optionsMenu/referencedInOptions/SelectableItemList';
import { unitListItems } from '@shared/util/durations';
import { I18nKey, i18n } from '@shared/util/i18n';

interface UnitMenuProps {
  count?: number;
  onUnitSelect: (unit: string) => void;
  selectedItem?: string;
  showRadios?: boolean;
}

export function UnitMenu({
  count = 0,
  onUnitSelect = () => {},
  selectedItem,
  showRadios = false,
}: UnitMenuProps) {
  const items = unitListItems.map(item => ({
    ...item,
    label: i18n(item.label as I18nKey, { count }),
  }));

  return (
    <SelectableItemList
      items={items}
      onSelectItem={onUnitSelect}
      enabled={true}
      selectedItem={selectedItem}
      showRadios={showRadios}
    />
  );
}
